export const currentCurrency = "RSD";

const extendedColorVariants = [
  "primary",
  "success",
  "info",
  "warning",
  "danger",
  "pink",
];

const colorVariants = [
  "primary",
  "secondary",
  "success",
  "danger",
  "warning",
  "info",
];

export { extendedColorVariants, colorVariants };
